import { render } from "./App.vue?vue&type=template&id=30c1ab4e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=30c1ab4e&lang=css"

import exportComponent from "/home/kirill/Projects/firebase/webauth/firebase-auth-spa/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__